// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise';
import 'core-js/es6/string';
import 'core-js/es7/array';
import 'jquery/dist/jquery.slim';
import 'bootstrap/dist/js/bootstrap.bundle';

import Vue from 'vue'
import VueI18n from 'vue-i18n';
import App from '@/views/App';
import router from './router';
import api from './api';
import MobileDetect from 'mobile-detect';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

// Load Sentry error log.
Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new Integrations.Vue({Vue, attachProps: true})],
});

window.Sentry = Sentry;

// // Load shared vue components automatically.
// const files = require.context('./shared/', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

Vue.prototype.$api = new api({
    baseURL: process.env.VUE_APP_API_URL
});

Vue.use(VueI18n);

// Two libraries for detecting device and browser. mobile-detect detects which device,
// while detect-browser finds the user-agent
Vue.prototype.$md = new MobileDetect(window.navigator.userAgent);

Number.prototype.pad = function(size) {
    var s = String(this);
    while (s.length < (size || 2)) {s = "0" + s;}
    return s;
};

let $state = {
    get logged_in() {
        return localStorage.getItem('MOVAVIEW_LOGIN') || false;
    },
    set logged_in(value) {
        localStorage.setItem('MOVAVIEW_LOGIN', value);
    },
    get login_info() {
        return JSON.parse(localStorage.getItem('MOVAVIEW_LOGIN_INFO')) || false;
    },
    set login_info(value) {
        localStorage.setItem('MOVAVIEW_LOGIN_INFO', JSON.stringify(value));
    },
    uploads: {
        in_progress: 0,
        // `failed` holds an array of arguments for the `uploadVideo` function.
        failed: [],
        completed: 0
    }
};

window.onbeforeunload = () => {
    return false;
};

Vue.prototype.$state = $state;

Vue.mixin({
    data() {
        return {
            $state: $state
        }
    },
    methods: {
        /**
         * Log data in console, and possibly to an external source.
         * @param text string
         * @param isError boolean
         */
        log(text, isError) {
            if(typeof text !== 'string') {
                text = JSON.stringify(text, null, '   ');
            }
            //if(text instanceof 'Object')
            console.log('[Movaview] ' + text);

            this.$api.logError(text, isError);
        },
        /**
         * Check if device has touchscreen.
         * @return {boolean}
         */
        hasTouchScreen() {
            return 'ontouchstart' in document.documentElement;
        },
        /**
         * Set if the browser tab can be closed without confirmation by the user.
         * @param {Boolean} value
         */
        setCanCloseApplication(value) {
            if(value) {
                window.onbeforeunload = null;
            } else {
                window.onbeforeunload = () => {
                    return 'Het programma is nog niet afgerond.';
                }
            }
        }
    }
});

window.VueI18n = new VueI18n({
      messages: {
            default: require('./lang/default.json')
        },
    locale: 'default',
});

/* eslint-disable no-new */
window.Vue = new Vue({
    i18n: window.VueI18n,
    el: '#app',
    router,
    template: '<App/>',
    created() {
        this.setCanCloseApplication(false);
    },
    mounted() {
        // Update translations on login.
        this.$root.$on('login', (response) => {
            // Merge with default translations, so missing keys still have a translation.
            let translations = Object.assign({}, window.VueI18n.getLocaleMessage('default'), response.data.taalzinnen);

            // Assign translations to VueI18n.
            window.VueI18n.setLocaleMessage('api', translations);
            window.VueI18n.locale = 'api';
        })
    },
    components: {
        App
    }
});
